import React from 'react';
import { motion } from 'framer-motion';
import './AnimatedParticles.css';

function AnimatedParticles() {
  const particles = Array.from({ length: 20 }, (_, i) => ({
    id: i + 1,
    size: Math.random() * 4 + 2,
    left: Math.random() * 100,
    top: Math.random() * 100,
    delay: Math.random() * 5,
    duration: Math.random() * 3 + 4,
  }));

  const floatVariants = {
    float: {
      y: [0, -20, 0],
      x: [0, 10, 0],
      opacity: [0.3, 0.6, 0.3],
      transition: {
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut',
      },
    },
  };

  return (
    <div className="animated-particles">
      {particles.map((particle) => (
        <motion.div
          key={particle.id}
          className="animated-particle"
          style={{
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            left: `${particle.left}%`,
            top: `${particle.top}%`,
          }}
          variants={floatVariants}
          animate="float"
          transition={{
            delay: particle.delay,
            duration: particle.duration,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
}

export default AnimatedParticles;
